var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoOffFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.335938,
    width: 50,
    height: 50,
    rx: 25,
    fill: "#E6E9E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0632 31.652L34.4463 36L35.9248 34.5333L15.2258 14L13.7473 15.4667L14.9938 16.7032H14.3814C13.804 16.7032 13.3359 17.1675 13.3359 17.7403V32.2595C13.3359 32.8323 13.804 33.2966 14.3814 33.2966H29.0178C29.5952 33.2966 30.0632 32.8323 30.0632 32.2595V31.652ZM29.0178 16.7032H20.8779L36.031 31.7351C36.211 31.6531 36.3359 31.4729 36.3359 31.2636V18.7362C36.3359 18.6298 36.3029 18.526 36.2414 18.4389C36.0759 18.2043 35.75 18.1472 35.5135 18.3114L30.0632 22.0961V17.7403C30.0632 17.1675 29.5952 16.7032 29.0178 16.7032Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoOffFill);
export default __webpack_public_path__ + "static/media/video-off-fill.6a4863fef49705e78b83a1c31a6cee60.svg";
export { ForwardRef as ReactComponent };